/**
 * Copia texto pra área de transferência. O navigator.clipboard só existe em https ou localhost;
 * acessando pela rede (http://192.168...) cai no plano B, um textarea escondido + execCommand.
 */
export async function copiarTexto(texto: string): Promise<void> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(texto);
      return;
    } catch {
      // permissão negada: tenta o plano B
    }
  }
  const area = document.createElement('textarea');
  area.value = texto;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.top = '-1000px';
  area.style.opacity = '0';
  document.body.appendChild(area);
  const foco = document.activeElement as HTMLElement | null;
  area.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(area);
  foco?.focus();
  if (!ok) throw new Error('Não consegui copiar. Selecione o texto e copie com Ctrl+C.');
}
